import axios from 'axios';
import fb from './db';
import store from '@/store';
var ax = axios.create({
  baseURL: process.env.VUE_APP_SERVER_URL || 'https://api.grocart.in',
});
ax.interceptors.request.use(async function(config) {
  if (fb.auth().currentUser) {
    config.headers[
      'Authorization'
    ] = await fb.auth().currentUser.getIdToken();
  }
  if (store.state.vid !== '' && store.state.vid !== undefined) {
    config.headers['vid'] = store.state.vid;
  }
  return config;
});
export default ax;
